export interface Category {
  articleCategory: Record<string, string>;
}
